import { useEffect } from 'react';

const excludePaths = [
  '/l/',
  '/locals/',
  '/become-a-host/',
];

type ScrollToTopProps = {
  newLocation?: any;
  history: any;
  isModal: boolean;
}

const ScrollToTop = ({ newLocation, history, isModal }: ScrollToTopProps) => {
  useEffect(() => {
    const exclude = excludePaths.some(path => newLocation?.pathname.includes(path));
    if (!isModal && history.action === 'PUSH' && !exclude) {
      window.scrollTo(0, 0);
    }
  }, [newLocation, isModal, history.action]);

  return null;
};

export default ScrollToTop;
